import { ALL } from '../../utils/types/genericTypes';
import { localAtom } from '../localStorageState';

export type CouponsGridFilters = {
  text: string;
  couponState: string;
  couponType: string;
};

export const withCouponsFilters = localAtom({
  key: 'payments.couponsFilters',
  default: {
    text: '',
    couponState: ALL,
    couponType: ALL
  }
});

export type PromotionsGridFilters = {
  text: string;
  status: string;
};

export const withPromotionsFilters = localAtom({
  key: 'payments.promotionsFilters',
  default: {
    text: '',
    status: ALL,
    audience: ALL,
    promoType: ALL
  }
});

export type PlansGridFilters = {
  text: string;
  promoGroup: string;
  device: string;
  countries: string[];
};

export const withPlansFilters = localAtom({
  key: 'payments.plansFilters',
  default: {
    text: '',
    promoGroup: ALL,
    device: ALL,
    countries: []
  } as PlansGridFilters
});

export type OfferMappingsGridFilters = {
  text: string;
};

export const withOfferMappingsFilters = localAtom({
  key: 'payments.offerMappingsFilters',
  default: {
    text: ''
  } as OfferMappingsGridFilters
});

export type SponsorsGridFilters = {
  text: string;
};

export const withSponsorsFilters = localAtom({
  key: 'payments.sponsorsFilters',
  default: {
    text: ''
  } as SponsorsGridFilters
});

export type CampaignsGridFilters = {
  text: string;
};

export const withCampaignsFilters = localAtom({
  key: 'payments.campaignsFilters',
  default: {
    text: ''
  } as CampaignsGridFilters
});
